import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Time-windowed clip player. Wraps `<video>` with a same-origin URL pointing
 * to `/api/cameras/{id}/clip?start_ms=&end_ms=`, which the orchestrator
 * resolves against VST's continuous recording (`/v1/storage/file/{id}/url`)
 * and streams back as MP4 bytes.
 *
 * Use this for alert clip-of-interest playback and for any time-anchored
 * inspection of an RTSP stream — VSS already keeps the recording, we just
 * carve out the window we need.
 */
export function ClipPlayer({ cameraId, startMs, endMs, autoPlay = false, }) {
    const src = `/api/cameras/${encodeURIComponent(cameraId)}/clip?start_ms=${startMs}&end_ms=${endMs}`;
    return (_jsx("video", { src: src, controls: true, muted: true, playsInline: true, autoPlay: autoPlay, preload: "metadata", style: { width: '100%', borderRadius: 'var(--r)', background: '#000', minHeight: 240 } }, src));
}
